export default __webpack_public_path__ + "static/media/DSC_7794-edited.670e8325.jpg";